// extracted by mini-css-extract-plugin
export default {"formContent":"UcVET6lUvW","message":"hjQsqtFxl7","avatarContainer":"QdWkTHbU70","buttons":"oTWkzrrRbo","imageContainer":"hm1GQ9qLn_"};